import bookshelf from './bookshelf/index.jsx';

// Every module the signage app can render. Adding the photo frame or the todo
// list means adding a file here - App.jsx builds its carousel from this list
// and knows nothing about what any module contains.
export const MODULES = [bookshelf];

// The panels on screen, which depend on the account's settings rather than
// being fixed.
//
// They used to be a constant, because there was one way to draw a bookshelf.
// There are now two, and they are not the same shape as each other: the
// classic theme is a shelf and a slideshow, the eight-bit level is one panel
// that owns the whole screen. So the carousel's contents are a function of the
// settings, and changing the theme changes how many panels there are.
//
// Panel ids carry the theme as well as the module, so an id from one theme can
// never resolve inside another - which is what makes clamping the active index
// on a theme change a real check rather than a coincidence.
export function panelsFor(settings) {
  return MODULES.flatMap((module) => {
    const theme = module.themeFor(settings);
    return theme.panels.map((panel) => ({
      ...panel,
      id: `${module.id}:${theme.id}:${panel.key}`,
      module,
      theme,
    }));
  });
}
